<template>
    <div class="dizhi">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <van-address-edit
                :area-list="areaList"
                show-postal
                show-delete
                show-set-default
                show-search-result
                :search-result="searchResult"
                :address-info="addressInfo"
                @save="onSave"
                @delete="onDelete"
        />
    </div>
</template>

<script>
    import {getCookie, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '编辑地址',
                token: '',
                adsId: '',
                areaList: {},
                searchResult: [],
                addressInfo: {},
            };
        },
        async created() {
            document.title = getDeptName()
            this.token = getCookie('spmToken')
            this.adsId = this.$route.params.adsId
            await this.getSpmSqus()
            await this.getAddress()
        },
        methods: {
            onSave(content) {
                this.saveSpmAddress(content)
            },
            onDelete() {
                this.delSpmAddress()
            },

            async saveSpmAddress(content) {
                content.token = this.token
                if (this.adsId) {
                    content.id = this.adsId
                }
                let res = await this.$post("/spm/saveSpmAddress", content)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.onClickLeft()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            async getAddress() {
                if (this.adsId) {
                    this.$toast.loading({
                        mask: true,
                        message: '加载中...',
                        duration: 1500,
                    });
                }
                let data = {
                    adsId: this.adsId
                }
                let res = await this.$get("/spm/getSpmAddressInfo", data)
                this.addressInfo = res.info
            },

            async getSpmSqus() {
                let res = await this.$get("/spm/getSpmSqus")
                this.areaList = res.areaList
            },
            async delSpmAddress() {
                let res = await this.$post("/spm/delSpmAddress", {adsId: this.adsId})
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.onClickLeft()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>

    .dizhi {
        padding-top: 50px;
        padding-bottom: 50px;
        overflow: scroll;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }


</style>
